export const COMPONENT_NAME = "shared-deposit";
